import { Component, Output, Input, OnInit, EventEmitter, OnDestroy } from '@angular/core';

import { BaseFormComponent } from '../../base-form.component';
import { StaticLocations } from 'src/assets/staticdata/static-locations';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import * as FieldValidators from 'src/app/shared/reactive-validators/fields.validator';
import { ErrorMessage } from 'src/app/shared/reactive-validators/error.message';

@Component({
  selector: 'app-state-dropdown[formGroup][propertyName]',
  templateUrl: './state-dropdown.component.html',
  styles: [],
  standalone: false,
})
export class StateDropdownComponent extends BaseFormComponent implements OnInit, OnDestroy {

  states;

  @Input() required? = true;
  @Output() userInput? = new EventEmitter<string>();
  @Input() regular?: boolean;

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnInit() {
    super.ngOnInit();
    this.setValidators();
    this.label = 'State';
    this.states = (StaticLocations as any).States;
  }

  ngOnDestroy(): void {
    this.formGroup.controls[this.propertyName].setValue('');
    this.formGroup.controls[this.propertyName].clearValidators();
    this.formGroup.controls[this.propertyName].updateValueAndValidity();
  }

  setValidators() {
    this.formGroup.controls[this.propertyName].clearValidators();
    if ( this.required ) {
      this.formGroup.controls[this.propertyName].setValidators([FieldValidators.requiredValidator(ErrorMessage.stateEmptyMsg)]);
      console.log('StateDropdownComponent setValidators this.required = ' + this.required);
    }
    this.formGroup.controls[this.propertyName].updateValueAndValidity();
  }

  userAction(input) {
    this.userInput.emit(input.target.value);
  }
}
